import { drugList, drugEdit, queryDrugSpu, drugListByKindId, drugListByArtNo, drugTypeConvert, edit, getInventoryApi, searchProperty } from '@/api/drug'
import { drugExcessList, drugExcessAdd, drugExcessEdit, drugExcessDelete } from '@/api/drugexcess'
import { effectsList, effectsAdd, effectsDelete } from '@/api/mutexdrugs'
import { getOtherProjectApi } from '@/api/outpatientDetail'
import { accountPropertyPage, accountPhysioProperty, usePhysio, physioDetail, getUsePhysioCode, physioRecord, executePhysioPage,revokePhysio,recordRecipe } from '@/api/physioexecute'
import { physioList } from "@/api/physio"; // 理疗请求
class drugDTO {
    /**
     * 获取药品库存列表
     */
    static getDrugList(params) {
        return new Promise((resolve, reject) => {
            drugList(params).then(res => {
                if (res.code == 200) {
                    let data = res.rows;
                    let options = []
                    if (!_.isEmpty(data)) {
                        let drugs = data.map(val => {
                            return {
                                itemId: val.spuId,
                                itemName: val.spuCommonName,
                                price: val.price,
                                artNo: val.id,
                                itemUnit: val.unit,
                                type: val.type,
                                inventory: val.inventory,
                                onSale: val.onSale || "0",
                                doseType: val.doseType || '0',
                                medicalInsuranceType:val.medicalInsuranceType

                            }
                        })
                        options = options.concat(drugs)
                    }
                    resolve(options)
                } else {
                    resolve([])
                }
            })
        })
    }

    /**
     * 获取药品库存列表
     */
    static drugEdit(params) {
        return new Promise((resolve, reject) => {
            drugEdit(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 获取药品目录列表
     */
    static queryDrugSpu(params) {
            return new Promise((resolve, reject) => {
              queryDrugSpu(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 根据药品种类查询药品
         */
    static drugListByKindId(params) {
            return new Promise((resolve, reject) => {
                drugListByKindId(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 根据药品货号查询药品信息
         */
    static drugListByArtNo(params) {
            return new Promise((resolve, reject) => {
                drugListByArtNo(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 转换药品类型
         */
    static drugTypeConvert(params) {
            return new Promise((resolve, reject) => {
                drugTypeConvert(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 修改价格和编码
         */
    static editDurg(params) {
            return new Promise((resolve, reject) => {
                edit(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 获取药品超量列表
         */
    static drugExcessList(params) {
            return new Promise((resolve, reject) => {
                drugExcessList(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 新增药品超量
         */
    static drugExcessAdd(params) {
            return new Promise((resolve, reject) => {
                drugExcessAdd(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 修改药品超量
         */
    static drugExcessEdit(params) {
            return new Promise((resolve, reject) => {
                drugExcessEdit(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 删除药品超量
         */
    static drugExcessDelete(params) {
            return new Promise((resolve, reject) => {
                drugExcessDelete(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 获取十八反十九畏列表
         */
    static effectsList(params) {
            return new Promise((resolve, reject) => {
                effectsList(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 新增十八反十九畏
         */
    static effectsAdd(params) {
            return new Promise((resolve, reject) => {
                effectsAdd(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 删除十八反十九畏信息
         */
    static effectsDelete(params) {
        return new Promise((resolve, reject) => {
            effectsDelete(params).then(res => {
                resolve(res)
            })
        })
    }

    //获取处方中药品库存
    static getInventory(obj) {
        return new Promise((resolve, reject) => {
            getInventoryApi(obj).then(res => {
                resolve(res)
            })
        })
    }

    //搜索非处方项目
    static getOtherProject(obj) {
        return new Promise((resolve, reject) => {
            getOtherProjectApi(obj).then(res => {
                if (res.code == 200) {
                    let data = res.data;
                    let options = []
                    if (!_.isEmpty(data.drugs)) {
                        let drugs = data.drugs.map(val => {
                            return {
                                itemId: val.spuId,
                                itemName: val.spuCommonName,
                                itemUnit: val.unit,
                                ...val
                            }
                        })
                        options = options.concat(drugs)
                    }
                    if (!_.isEmpty(data.physioInfos)) {
                        let physio = data.physioInfos.map(val => {
                            return {
                                itemId: val.spuId,
                                itemName: val.spuCommonName,
                                price: val.price,
                                artNo: val.id,
                                itemUnit: '次',
                            }
                        })
                        options = options.concat(physio)
                    }
                    resolve(options)
                } else {
                    resolve([])
                }
            })
        })
    }

    /**
     * 获取理疗列表
     */
    /**
     * 获取药品库存列表
     */
    static getPhysioList() {
            return new Promise((resolve, reject) => {
                physioList().then(res => {
                    if (res.code == 200) {
                        let data = res.rows;
                        let options = []
                        if (!_.isEmpty(data)) {
                            let physio = data.map(val => {
                                return {
                                    itemId: val.spuId,
                                    itemName: val.spuCommonName,
                                    price: val.price,
                                    itemUnit: val.unit,
                                    perUnit:val.perUnit,
                                    ...val
                                }
                            })
                            options = options.concat(physio)
                        }
                        resolve(options)
                    } else {
                        resolve([])
                    }
                })
            })
        }
        /**
         * 分页查询账户理疗信息
         */
    static getAccountPropertyPage(params) {
            return new Promise((resolve, reject) => {
                accountPropertyPage(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 查询患者理疗资产信息
         */
    static getAccountPhysioProperty(params) {
        return new Promise((resolve, reject) => {
            accountPhysioProperty(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 执行理疗项目
     */
    static usePhysio(params) {
            return new Promise((resolve, reject) => {
                usePhysio(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 理疗详情查看
         */
    static physioDetail(params) {
            return new Promise((resolve, reject) => {
                physioDetail(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 获取核销理疗项目编码
         */
    static getUsePhysioCode(params) {
            return new Promise((resolve, reject) => {
                getUsePhysioCode(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 患者Id查询理疗执行记录
         */
    static physioRecord(params) {
            return new Promise((resolve, reject) => {
                physioRecord(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 获取执行看板数据
         */
    static executePhysioPage(params) {
            return new Promise((resolve, reject) => {
                executePhysioPage(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 查询商品库存以及禁用标识
         */
    static searchProperty(params) {
        return new Promise((resolve, reject) => {
            searchProperty(params).then(res => {
                resolve(res)
            })
        })
    }
    //撤销执行理疗项目
    static revokePhysio(params) {
      return new Promise((resolve, reject) => {
        revokePhysio(params).then(res => {
              resolve(res)
          })
      })
    }
    //查询处方内理疗执行记录
    static recordRecipe(params) {
      return new Promise((resolve, reject) => {
        recordRecipe(params).then(res => {
              resolve(res)
          })
      })
    }
}


export { drugDTO }